import { SET_SUCCESS, SET_ERROR, SET_IS_LOADING } from "../actions/types";

const initialState = {
    error:"",
    success:"",
    isLoading:false
}
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_ERROR:
            return { ...state,error: payload };
        case SET_SUCCESS:
            return { ...state,success: payload };
        case SET_IS_LOADING:
            return { ...state,isLoading: payload };
        default:
            return state;
    }
};